import { useRef, useState } from 'react'

export const useTurnstile = () => {
  const turnstileRef = useRef(null)
  const [turnstileToken, setTurnstileToken] = useState(null)

  const getTurnstileToken = async () => {
    if (typeof window === 'undefined') return null

    try {
      // First try to get existing token
      const token = turnstileToken || turnstileRef.current?.getResponse()
      if (token) return token

      // If no token, reset and execute
      turnstileRef.current?.reset()
      turnstileRef.current?.execute()

      // Wait for new token (max 5 seconds)
      let attempts = 0
      while (attempts < 50) {
        const newToken = turnstileRef.current?.getResponse()
        if (newToken) return newToken
        await new Promise(resolve => setTimeout(resolve, 100))
        attempts++
      }

      throw new Error('Failed to get Turnstile token')
    } catch (error) {
      console.error('Turnstile token error:', error)
      return null
    }
  }

  return {
    getTurnstileToken,
    turnstileRef,
    setTurnstileToken,
  }
}
